import React from 'react';
import AboutOne from '../../components/About/AboutOne';
const About = () => {
    return (
        <>
            {/* About One Start */}
            <AboutOne />
            {/* About One End */}
        </>
    );
}

export default About;
